function Dipespgestrecursoshumanos() {
     return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Gestión de Recursos Humanos en el Sector Público 
                    brinda formación integral y actualizada sobre planificación, administración y 
                    desarrollo del personal en las entidades públicas, promoviendo competencias 
                    técnicas y estratégicas en la gestión del capital humano.
               </p>
               <p>
                    El programa aborda contenidos vinculados a planificación y desarrollo del personal, 
                    administración de la carrera administrativa, sistemas de remuneraciones, 
                    evaluación del desempeño, clima laboral, liderazgo y gestión del talento.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar competencias técnicas y estratégicas para gestionar 
                            eficientemente los recursos humanos en el sector público, optimizando 
                            la administración del talento y contribuyendo al fortalecimiento institucional.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img 
                    src='/uploads/curs_recursos_humanos.jpg' 
                    alt='logo-de-metodologia' 
                    className='logo-metodologia'
                />
                
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 Teléfonos y WhatsApp: 913376365 / 948251685</p>
                        <p>📧 Correos: esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Planificación y Desarrollo del Personal </li>
                    <li> 2. Carrera Administrativa </li>
                    <li> 3. Sistemas de Remuneraciones </li>
                    <li> 4. Evaluación del Desempeño </li>
                    <li> 5. Clima Laboral </li>
                    <li> 6. Liderazgo y Gestión del Talento </li>
                </ul>
            </div>
        </div>
    );
}
export default Dipespgestrecursoshumanos
